module.exports = __webpack_public_path__ + "static/prem-finance-team-2e13d48a8fee0df511009e0636a1c04a.png";